<template>
  <div class="famousCard">
    <div  class="proTxt" v-show="famousShow">
            <div>
              <img src="../../../../static/image/defaultpic.png" alt=""  height="140" />
            </div>
            <p :style="{'marginTop': '23px'}"> 未查询到符合条件记录</p>
    </div>
    <ul v-show="famousHide">
      <li v-for="(item,index) in famousList">
        <div class="docIntroduct"  @click="jump(item.doctorId)">
          <img class="iconfont icon-touxiang" v-if="item.photoUrl!== undefined" :src="item.photoUrl" alt="">
          <img class="iconfont icon-touxiang" v-else src="../../../../static/image/user.png" alt="">
          <div class="rightContent">
            <div class="spacing"><span class="doctorName">{{item.name}}</span><span class="docTitle">{{item.professionTitle}}</span></div>
            <div class="spacing">{{item.hospitalName}}</div>
            <div class="spacing"><span>课程</span><span class="courseNum">{{item.courseCount}}</span></div>
          </div>
        </div>
        <div class="sideCont">
          <div class="model" v-for="(itemTwo,index) in item.courseList"   @click="jump2(itemTwo.id)">
            <img v-if="itemTwo.courseImg!== undefined" :src="itemTwo.courseImg" alt="">
            <img v-else src="../../../../static/image/default.png" alt="">
            <p>{{itemTwo.subject}}</p>
          </div>
          <div class="bit"  @click="jump(item.doctorId)">
            <span class="dot" v-for="(item,index) in 3"></span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script type="text/ecmascript-6">
  import {clearLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  export default {
    props: {
      famousList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        hasAvatar:false,
        famousShow: false,
        famousHide: true
      }
    },
    watch: {
      // famousList(c) {
      //   if(c.length!==0){
      //     this.famousShow = false
      //     this.famousHide = true
      //   } else if(c.length===0) {
      //     this.famousShow = true
      //     this.famousHide = false
      //   }
      //   for (let item of this.tecahCardList) {
      //     item.onShelfTime = getDateDiff(item.onShelfTime)
      //   }
      // }
    },
    mounted() {
    },
    methods: {

      jump(val) {
        saveLocalStorage(val, 'famousId')
        this.$emit('popShow2',true)
        // this.$router.push({name: 'TeachDetail'})
      },
      jump2(val){
        saveLocalStorage(val, 'Id')
        this.$emit('popShow',true)
        // this.$router.push({name: 'CourseEvaluat'})
      }

    },
    created() {
      // clearLocalStorage('famousId')
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'
  .famousCard
    margin-top: 10px
    min-height: calc(100vh - 300px)
    overflow-y: auto
    .proTxt
      text-align: center
      align-items center
      font-size: 16px
      width: 100%
      margin-top 100px
      min-height: calc(100vh - 270px);
    ul
      overflow: hidden
      li
        float: left
        width: 100%
        height: 120px
        margin: 10px 0
        padding: 0 17px
        box-sizing: border-box
        border-radius: 8px
        cursor: pointer
        position: relative
        overflow: hidden
        .docIntroduct
          width: 330px
          height: 100%
          overflow: hidden
          float: left
          img
            width: 90px
            height: 90px
            border-radius: 50%
            overflow: hidden
            margin: 15px 20px 0 0
            float: left
          .rightContent
            float: left
            width: calc(100% - 115px)
            padding: 23px 0
            box-sizing: border-box
            .spacing
              margin-bottom: 15px
              .doctorName
                color: #000
                font-size: 15px
              .doctorName:hover
                color:#00abad
                font-size: 15px
                .difColor
                  color: $color-green
              .docTitle
                margin-left: 25px
              .courseNum
                margin-left: 10px
                color: #000
        .sideCont
          width: calc(100% - 330px)
          float: left
          height: 100%
          position: relative
          .model
            width: 185px
            float: left
            height: 100%
            margin: 8px 28px
            img
              width: 100%
              height: 60%
              max-width: 300px
              margin: auto
              border-radius: 8px
             img:hover
              box-shadow: 10px 10px 5px #888888
            p
              text-align: center
              color: #000000
              line-height: 24px
              margin-top: 8px
              overflow: hidden
              white-space:nowrap
              text-overflow:ellipsis
            p:hover
              color: $color-green
          .bit
            width: 30px
            float: left
            height: 100%
            padding-top: 33px
            margin-left: 13px
            position: absolute
            right: 0
            .dot
              display: block
              width: 5px
              height: 5px
              background: #909090
              margin: 5px auto
              border-radius: 50%
              overflow: hidden
</style>



// WEBPACK FOOTER //
// famousCard.vue?20f44144